import PosthogService from '~/services/posthog/PosthogService';

export interface IEndOfDayTimeConfirmedPayload {
  shiftId: string;
}

/**
 * Fires when an office confirms an adjustment from inside the "Confirm
 * Adjustment" pop-up.
 * Event: dental_portal:end_of_day:time_confirmed
 */
export function fireEndOfDayTimeConfirmed(payload: IEndOfDayTimeConfirmedPayload): void {
  PosthogService.getInstance().track('dental_portal:end_of_day:time_confirmed', {
    shift_id: payload.shiftId,
  });
}
